module.exports = __webpack_public_path__ + "img/2_inspection-car-sp.93a696d5.gif";